export var SERVER_URL = localStorage.getItem("server");
export var POP_MESSAGE = true;
export function hasPrivilege(user, privilege) {
  // TO DELETE
  if (!user) return true;

  if (!user.privileges) return false;
  if (user.type == "sysadmin") return true;
  return user.privileges.indexOf(privilege) != -1;
}
export function hasSsrPrivilege(settings, privilege) {
  return settings.data.features[privilege];
}
export function TOGGLE_POP() {
  POP_MESSAGE = !POP_MESSAGE;
}
export function long2ip(int) {
  var part1 = int & 255;
  var part2 = (int >> 8) & 255;
  var part3 = (int >> 16) & 255;
  var part4 = (int >> 24) & 255;

  return part4 + "." + part3 + "." + part2 + "." + part1;
}
export function ip2long(ip) {
  var d = ip.split(".");
  return ((+d[0] * 256 + +d[1]) * 256 + +d[2]) * 256 + +d[3];
}
export function ips2range(start, end) {
  var start_range = ip2long(start);
  var end_range = ip2long(end);
  var arr = [];
  for (let i = start_range; i <= end_range; i++) {
    arr.push(long2ip(i));
  }
  return arr;
}
export function export_csv(table_id, filename) {
  const table = document.getElementById(table_id);
  const rows = table.querySelectorAll("tr");
  let csv = [];

  for (let row of rows) {
    let cols = row.querySelectorAll("td, th");
    let rowData = [];
    for (let col of cols) {
      rowData.push(`"${col.innerText.replace(/"/g, '""')}"`);
    }
    csv.push(rowData.join(","));
  }

  let csvFile = new Blob([csv.join("\n")], { type: "text/csv" });
  let downloadLink = document.createElement("a");
  downloadLink.download = `${filename}.csv`;
  downloadLink.href = URL.createObjectURL(csvFile);
  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}
export function print_element(id) {
  // Get HTML to print from element
  const prtHtml = document.getElementById(id).innerHTML;

  // Get all stylesheets HTML
  let stylesHtml = "";
  for (const node of [
    ...document.querySelectorAll('link[rel="stylesheet"], style'),
  ]) {
    stylesHtml += node.outerHTML;
  }

  const page = `<!DOCTYPE html>
  <html>
    <head>
      ${stylesHtml}
      <style>
      .sortable {
        cursor: pointer;
        user-select: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .sortable:hover .arrow-up,
      .sortable:hover .arrow-down {
        color: #ccc; /* Slightly darker on hover */
      }

      .column-title {
        text-transform: uppercase;
        color: #333; /* Dark text color */
      }

      .sort-arrows {
        display: flex;
        flex-direction: column;
        margin-left: 8px;
      }

      .arrow-up,
      .arrow-down {
        display: block;
        line-height: 1;
        color: transparent; /* Default gray color for inactive arrows */
        transition: color 0.2s ease;
      }

      .sortable[data-sort="asc"] .arrow-up {
        color: #666; /* Darker color for active ascending arrow */
      }

      .sortable[data-sort="desc"] .arrow-down {
        color: #666; /* Darker color for active descending arrow */
      }
                  /* Screen styles for preview */
          .bill-container {
            margin: 20px auto;
            padding: 10mm;
            background: white;
            font-family: Arial, sans-serif;
          }

          .bill-content {
            color: black;
            background: white;
          }

          .bill-header,
          .bill-details,
          .bill-summary,
          .bill-issuer,
          .bill-notes,
          .bill-footer {
            margin-bottom: 5mm;
          }

          .bill-header,
          .bill-footer {
            text-align: center;
          }

          .company-logo,
          .signature {
            max-height: 80px;
          }

          .company-name {
            font-size: 1.5rem;
            font-weight: bold;
          }

          .bill-details {
            display: flex;
            justify-content: space-between;
            gap: 20px;
          }

          .customer-info,
          .invoice-info {
            flex: 1;
          }

          .info-row,
          .summary-item {
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
          }

          .bill-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 5mm;
          }

          .bill-table th,
          .bill-table td {
            border: 1px solid black;
            padding: 5pt;
            text-align: left;
          }

          .bill-table th {
            background-color: #f2f2f2;
          }

          .bill-table tfoot {
            font-weight: bold;
          }

          .print-button {
            padding: 10px 20px;
            background-color: #007bff;
            color: white;
            border: none;
            cursor: pointer;
            margin-bottom: 10mm;
          }

          .print-button:hover {
            background-color: #0056b3;
          }
      </style>
    </head>
    <body style="background-color: white;">
      ${prtHtml}
    </body>
  </html>`;
  // Open the print window
  const WinPrint = window.open(
    "",
    "",
    "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0",
    page,
  );

  WinPrint.document.open();
  WinPrint.document.write(page);

  WinPrint.document.close();
  window.focus();
  WinPrint.print();
  WinPrint.addEventListener("afterprint", () => {
    WinPrint.close();
  });
  // WinPrint.close();
}
export async function export_pdf(table_id, file_name) {
  const table = document.getElementById(table_id);
  const clone = table.cloneNode(true);

  // Remove the first two columns
  clone.querySelectorAll("tr").forEach((row) => {
    row.removeChild(row.children[0]); // remove col 1
    row.removeChild(row.children[0]); // remove col 2 (now first)
  });

  // Create wrapper
  const container = document.createElement("div");
  container.appendChild(clone);

  const theadRows = clone.querySelectorAll("thead tr");
  if (theadRows.length > 1) {
    theadRows[1].remove(); // remove second row in thead
  }
  html2pdf()
    .from(container)
    .set({
      filename: file_name,
      html2canvas: { scale: 2 },
      jsPDF: { orientation: "landscape" },
    })
    .save();
}
export function print_table(id) {
  const original = document.getElementById(id);
  const clone = original.cloneNode(true);

  // Remove second row of thead
  const thead = clone.querySelector("thead");
  if (thead && thead.rows.length > 1) {
    thead.deleteRow(1);
  }

  // Remove first two columns
  clone.querySelectorAll("tr").forEach((row) => {
    if (row.cells.length >= 2) {
      row.deleteCell(0);
      row.deleteCell(0);
    }
  });

  // Create new print window
  const printWindow = window.open(
    "",
    "",
    "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0",
  );
  const stylesheets = [...document.querySelectorAll('link[rel="stylesheet"]')]
    .map((link) => `<link rel="stylesheet" href="${link.href}">`)
    .join("\n");
  printWindow.document.write(`
    <html lang="ar" dir="rtl">
      <head>
        <title>طباعة الجدول</title>
        ${stylesheets}
      </head>
      <body>
        ${clone.outerHTML}
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = () => window.close();
          }
        <\/script>
      </body>
    </html>
  `);
  printWindow.document.close();
}
